import _fonts      from "theme/generic/_fonts.scss";
import _normalize  from "theme/generic/_normalize.scss";
import _base       from "theme/generic/_base.scss";
import _typography from "theme/generic/_typography.scss";
import _helpers    from "theme/generic/_helpers.scss";
import _rows       from "theme/objects/_rows.scss";

// We need to initialize this early before we import any of the fetch wrappers
// or other resources to ensure RUM installs correctly:
import { datadogRum } from "@datadog/browser-rum";
import config from "../config.js";

const datadogIsEnabled = true;

if (datadogIsEnabled && config.datadog) {
  datadogRum.init(Object.assign(
    config.datadog,
    { trackInteractions: true },
  ));
}

import CoreJs      from "core-js";

import { h, render }              from "preact";
import { Provider }               from "preact-redux";
import { mkStore }                from "./store";
import { APP_KEY,
         Shared }                 from "./shared";
import { ConnectedRouter }        from "react-router-redux";
import { Route }                  from "react-router";
import { createBrowserHistory }   from "history";
import whatInput                  from "what-input";
// import WithContext                from "containers/WithContext";
import { WithGoogleAnalytics }    from "redux-enhancer-google-analytics";
import { WithBrowserDimensions }  from 'redux-browser-dimensions';
import { prefix,
         HttpError,
         withCookies }      from "fetch-utilities";
import fetch                from "isomorphic-fetch";
import translation          from "translation";

import { watch } from "@crossroads/dev-server";

const rejectOnHttpError = function rejectOnHttpError(fetch) {
  return function (input, init) {
    // Store a stack-trace here in case we error
    var stackTrace = null;

    // Skip this for production
    if (process.env.NODE_ENV !== "production") {
      stackTrace = new Error("fetch() called here");
    }

    return fetch(input, init).then(function (resp) {
      if (resp instanceof Response && !resp.ok) {
        return resp.json().then(function (errData) {
          datadogRum.addError(errData);
          throw new HttpError(resp, stackTrace, errData);
        },
        // We might fail JSON-parse
        function () {
          datadogRum.addError(resp);
          throw new HttpError(resp, stackTrace);
        });
      }

      return resp;
    });
  };
};

const root    = document.getElementById(APP_KEY);
const history = createBrowserHistory();
const client  = rejectOnHttpError(withCookies(prefix(fetch, config.apiHost.client)));

// Boot up watch-process in dev mode to make sure we reload
if (process.env.NODE_ENV !== "production") {
  watch({ port: 6001 });
}

window[APP_KEY] = mkStore(window[APP_KEY] && window[APP_KEY].getState ? window[APP_KEY].getState() : window[APP_KEY], history, client);

render(<div id={APP_KEY} class="root">
  <Provider store={window[APP_KEY]}>
    <WithGoogleAnalytics ga={window[APP_KEY].googleAnalytics}>
      <WithBrowserDimensions>
        {/* <WithContext translation={translation} client={client}> */}
          <ConnectedRouter history={history}>
            <Route>
              <Shared translation={translation} />
            </Route>
          </ConnectedRouter>
        {/* </WithContext> */}
      </WithBrowserDimensions>
    </WithGoogleAnalytics>
  </Provider>
</div>, null, root);
